var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-input",
    { ref: "inputComponent", attrs: { value: _vm.value } },
    [
      _c(
        "multiselect",
        _vm._b(
          {
            staticClass: "banner-filter-input",
            attrs: {
              id: _vm.id,
              label: "displayTitle",
              "track-by": "id",
              options: _vm.options,
              multiple: true,
              searchable: true,
              loading: _vm.isLoading,
              "internal-search": false,
              "close-on-select": false,
              "show-no-results": true,
              "hide-selected": false,
              "max-height": 400,
              clear: true,
              "auto-complete": false,
              value: _vm.bindValue(),
              allowEmpty: true
            },
            on: {
              "search-change": _vm.asyncFindBanners,
              input: function($event) {
                return _vm.updateValue($event)
              }
            }
          },
          "multiselect",
          _vm.$attrs,
          false
        ),
        [
          _c("span", { attrs: { slot: "noResult" }, slot: "noResult" }, [
            _vm._v("No items matching query.")
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }